import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { subscribeGlobalError } from '../utils/functions/globalError';
import StatusCodeBadge from './StatusCodeBadge';
import { translateHttpStatus, translateNonHttpError } from '../utils/functions/httpStatusThai';

// แสดง dialog แจ้ง error ให้ user เห็นทุกครั้งที่ API ตอบ error หรือมี promise rejection
// ที่ไม่ถูก catch ที่ไหนเลย — mount ครั้งเดียวที่ root (index.js) ครอบคลุมทั้งแอป
const GlobalErrorDialog = () => {
  const [message, setMessage] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(
    () => subscribeGlobalError((msg, code) => {
      setMessage(msg);
      setStatus(code ?? null);
    }),
    [],
  );

  useEffect(() => {
    const handleRejection = (event) => {
      // axios interceptor (utils/functions/api.js) แจ้ง dialog ไปแล้ว — กันไม่ให้เด้งซ้ำ
      if (event.reason?.__globalErrorHandled) {
        event.preventDefault();
        return;
      }
      const { reason } = event;
      const msg =
        reason?.response?.data?.error?.message ||
        reason?.message ||
        (typeof reason === 'string' ? reason : null) ||
        'เกิดข้อผิดพลาดที่ไม่คาดคิด';
      setMessage(msg);
      setStatus(reason?.response?.status ?? null);
      event.preventDefault();
    };
    window.addEventListener('unhandledrejection', handleRejection);
    return () =>
      window.removeEventListener('unhandledrejection', handleRejection);
  }, []);

  return (
    <Dialog
      open={!!message}
      onClose={() => setMessage(null)}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        style={{ display: 'flex', alignItems: 'center', gap: 12, color: '#d32f2f' }}
      >
        <StatusCodeBadge code={status} variant="error" />
        เกิดข้อผิดพลาด
      </DialogTitle>
      <DialogContent>
        {(() => {
          const mainText = status != null ? translateHttpStatus(status) : translateNonHttpError(message);
          return (
            <>
              <DialogContentText
                style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', fontWeight: 600, color: '#212121' }}
              >
                {mainText}
              </DialogContentText>
              {message && message !== mainText && (
                <DialogContentText
                  style={{ whiteSpace: 'pre-wrap', fontSize: '0.72rem', color: '#9e9e9e', marginTop: 10 }}
                >
                  {message}
                </DialogContentText>
              )}
            </>
          );
        })()}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setMessage(null)} variant="contained">
          ตกลง
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalErrorDialog;
